import React, {useState} from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import CommonUtil from 'utils/CommonUtil';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import noImg from 'assets/img/pages/usr_noimg.png';
import UI from "../../../../components/UI";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "domain/main/com/file/mapng/TbComFileMapngDetail";
import UIUtils from "utils/UIUtils";
import PageLoading from "../../../../components/loading";
import UIUtil from "utils/UIUtils";
import TbSYsNoti from "domain/main/sys/noti/TbSysNoti"

function ContentsContainer() {
    const history = useHistory();
    const location = useLocation();
    const [boardList, setBoardList] = useState<any[]>([]);
    const [totalCnt,setTotalCnt] = useState(0);
    const [searchDivCd, setSearchDivCd] = useState('0'); // 제목/내용 선택
    const [searchText, setSearchText] = useState('');
    const [notiTpCd, setNotiTpCd] = useState('E');
    const [notiList, setNotiList] = React.useState<React.JSX.Element[]>();

    // 페이징 설정
    const [pageNum, setPageNum] = useState(1);      // 페이지 번호
    const [pageSize, setPageSize] = useState(10);    // 화면에 출력할 목록 갯수(10개)

    const [thumbFile, setThumbFile] = useState(new TbComFileMapngDetail());
    const [imgSrc, setImgSrc] = useState('');

    const handleSelect = (e) => {
        setSearchDivCd(e.target.value);
    };

    async function getRead() {

        let param ={
                    "NOTI_TP_CD" : notiTpCd,
                    "SEARCH_DIV_CD": searchDivCd,
                    "SEARCH_TEXT": searchText,
                    "PAGE_NUM": pageNum,
                    "PAGE_SIZE": pageSize
                }

        const response:any = await CommonUtil.execute({
            url: 'usr_1903',
            data: param
        }).then((response: any) => {

            setBoardList(response.REC);
            debugger;
            //전체ROW개수
            setTotalCnt(response.TOTAL);

            let boardinfos : {TITLE; THUMB;}[] = [];

            const result = response.REC;
            console.log(result);

            // result.filter(tbSysNoti => tbSysNoti.getFile().tbComFileMapngDetailList[0].fileGb == "THUMB")
            //     .map(tbSysNoti => UIUtil.getFile(tbSysNoti.getFile().tbComFileMapngDetailList[0])
            //         .then(fileBlob => fileBlob ? UIUtil.blobToUrl(fileBlob) : "")
            //         .then(fileUrl => (
            //             <></>
            //         ))
            //     )
            // .then(value => {
            //     setNotiList(value);
            // })



        }).catch((error) => {
            CommonUtil.showAxiosError(error);
            return;
        });

    }

    //인풋 엔터체크
    const activeEnter = (e) => {
        // console.log(e.key);
        if(e.key === "Enter") {
            getRead();
        }
    }

    async function pageMove(notiNo) {
        let dataToSend = {NOTI_NO : notiNo};
        // 다른 페이지로 이동하면서 데이터 전달
        history.push({
          pathname: './usr_1906',
          state: { data: dataToSend }
        });
    }

    // 썸네일 이미지
    async function getBase64(tbComFileMapngDetail: TbComFileMapngDetail){

        const response:any = await CommonUtil.execute({
            url:'com_fileDownload',
            data: { DWLD_ID: tbComFileMapngDetail.getDwldId() }
        })

        const mineType = tbComFileMapngDetail.mimeType;
        const fileContent = `data:${mineType};base64,${response.FILE_LIST[0].FILE_NM}`

        // setImgSrc(fileContent);
        return fileContent;
    }

    React.useEffect(() => {
        getRead();
    },[pageNum])

    // 제목 텍스트 입력 후 엔터 시 리로딩 방지
    const submitHnadler = (e) => {
        e.preventDefault();
    }

	return (
		<PageContainer session={false}>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="#">상생협력기금안내</Link></li>
					<li><Link to="#">우수사례</Link></li>
				</ul>
				<main className="fww-main" data-layout="usr">
					<h1 className="tx tx-hd2">우수사례</h1>
                    <div className="fww-intro">
                        <form name="" action="" method="" onSubmit={submitHnadler}>
                            <div className="tb-search-form">
                                <div className="tb-search-items">
                                    <div className="sl sl-big">
                                        <select name="searchDivCd" id="searchDivCd" value={searchDivCd}
                                                onChange={handleSelect}>
                                            <option value="0">전체</option>
                                            <option value="1">제목</option>
                                            <option value="2">내용</option>
                                        </select>
                                    </div>
                                    <UIInput className={'tf tf-big ml10'} value={searchText} placeholder={"입력하세요."}
                                             valueChanged={(value) => setSearchText(value)}
                                             onKeyEnter={(e) => activeEnter(e)}/>
                                </div>
                                <Button color="pri" size="big" onClick={getRead}>검색</Button>
                            </div>
                        </form>

                        <ul className="gallery-list">
                            {boardList != null &&
                                boardList.map((board, index) => (
                                    index <= 9 &&
                                    <li>
                                        <a href="#" onClick={(e) => {
                                            e.preventDefault();
                                            pageMove(board.NOTI_NO);
                                        }} className="gallery-items">
                                            <div className="thumnails">
                                                {board.FILE_NM != '' ?
                                                    (
                                                        <img
                                                            src={'data:application/octet-stream;base64,' + board.FILE_NM}
                                                            alt="thumnails"/>
                                                    ) : (
                                                        <img src={noImg} alt="thumnails"/>
                                                    )
                                                }
                                            </div>
                                            <div className="subject"><span className="txt">{board.NOTI_TITLE}</span>
                                            </div>
                                            <div className="bottoms"><span className="date">{board.REG_DATE}</span>
                                            </div>
                                        </a>
                                    </li>
                                ))
                            }
                        </ul>
                        {boardList.length <= 0 &&
                            <div className="nd">
                                <p className="tx tx-cp2 fc-666">검색된 정보가 없습니다.</p>
                            </div>
                        }

                        <UI.PaginationBar
                            totalCnt={totalCnt}
                            rowCnt={10}
                            currentPage={pageNum}
                            onChange={(current:number) => {
                                setPageNum(current);
                            }}
                        />

					</div>
				</main>
			</div>			
		</PageContainer>
	);
}
export default ContentsContainer;